module.exports = __webpack_public_path__ + "img/finland-neoplasm-male.5ca8ba20.png";